import React, {Component} from 'react';
import {Drawer, Typography, IconButton, Divider} from '@material-ui/core/';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './store/actions/index'
import classNames from 'classnames';
import UserNote from 'main/components/note/UserNote';

const drawerWidth = 600;

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: 430,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%'
    },
    appBar: {
        position: 'absolute',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`
        }
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    drawer: {

    },
    drawerShift: {
        width: drawerWidth,
        flexShrink: 0,
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3
    },
    dragger: {
        width: '5px',
        cursor: 'ew-resize',
        padding: '4px 0 0',
        borderTop: '1px solid #ddd',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: '100',
        // backgroundColor: '#f4f7f9'
    },
});

class QuickPanel extends Component {
    state = {
        mobileOpen: false,
        isResizing: false,
        lastDownX: 0,
        newWidth: {},
    };

    constructor(props) {
        super(props);
        this.handleMousemove.bind(this);
    }

    handleMousedown = e => {
        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        
        this.setState({ isResizing: true, lastDownX: e.clientX });
    };

    handleMouseup = e => {
        this.setState({ isResizing: false });
    };

    handleMousemove = e => {
        if (!this.state.isResizing) {
            return;
        }

        let offsetRight = document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
        let minWidth = 200;
        let maxWidth = 1200;
        if (offsetRight > minWidth && offsetRight < maxWidth) {
            this.setState({ newWidth: { width: offsetRight } });
        }
    };

    componentDidMount() {
        document.addEventListener('mousemove', e => this.handleMousemove(e));
        document.addEventListener('mouseup', e => this.handleMouseup(e));
    }

    getDrawerStyle = (quick_panel_state, new_width) => {
        if (typeof new_width === 'undefined') new_width = drawerWidth;

        if(quick_panel_state) {
            return {
                width: new_width,
            }
        }

        return {}
    }

    render()
    {
        const { classes, state, toggleQuickPanel, userNoteList, auth } = this.props;
        const auth_id = auth.user.data.auth_id;
        
        return (
            <Drawer
                style={this.getDrawerStyle(state, this.state.newWidth.width)}
                variant="persistent"
                anchor={'right'}
                open={state}
                onClose={() => toggleQuickPanel(false)}
                classes={{
                    paper: classes.drawerPaper
                }}
                ModalProps={{
                    keepMounted: true // Better open performance on mobile.
                }}
                PaperProps={{ style: this.state.newWidth }}
            >
                <div
                    id="dragger"
                    onMouseDown={event => {
                        this.handleMousedown(event);
                    }}
                    className={classes.dragger}
                />
                { auth_id ? <UserNote /> : '' }
            </Drawer>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        toggleQuickPanel: Actions.toggleQuickPanel
    }, dispatch);
}

function mapStateToProps({quickPanel, auth})
{
    return {
        state:        quickPanel.state,
        auth:         auth,
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(QuickPanel));



// WEBPACK FOOTER //
// src/main/quickPanel/QuickPanel.js